/**
 * Display helpers for Manufacturer invoicing tables.
 */

export function formatQuantity(value: number | string | null | undefined): string {
  if (value == null || value === "") return "—";
  const text = String(value).trim();
  if (text === "") return "—";

  if (/^-?\d+(\.\d+)?$/.test(text)) {
    if (!text.includes(".")) return text.replace(/^(-?)0+(?=\d)/, "$1") || "0";
    const trimmed = text.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
    return trimmed === "-0" || trimmed === "" ? "0" : trimmed;
  }

  const parsed = typeof value === "number" ? value : Number.parseFloat(text);
  if (!Number.isFinite(parsed)) return text;
  if (Number.isInteger(parsed)) return String(parsed);
  return String(parsed);
}

export function parseManufacturerInvoiceMoney(value: number | string | null | undefined): number | null {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  const parsed = Number.parseFloat(value.replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatMoney(value: number | string | null | undefined): string {
  const parsed = parseManufacturerInvoiceMoney(value);
  if (parsed == null) {
    if (value == null || value === "") return "—";
    return String(value);
  }
  return parsed.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function manufacturerInvoiceTotalsMatch(
  matchedTotal: number | string | null | undefined,
  invoiceTotal: number | string | null | undefined,
): boolean {
  const matched = parseManufacturerInvoiceMoney(matchedTotal);
  const invoice = parseManufacturerInvoiceMoney(invoiceTotal);
  if (matched == null || invoice == null) return false;
  return Math.abs(matched - invoice) < 0.005;
}

